/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */

import { Image, Transformation } from "cloudinary-react";
import React from "react";
import "./Echo.css";

import {
  TopAnnotation,
  TopAnnotationConfig,
  topAnnotationDemoProps1,
} from "../TopAnnotation/TopAnnotation";
import {
  InlinePlayableTawkPill,
  InlinePlayableTawkPillConfig,
  inlinePlayableTawkPillConfigDemo1,
} from "../InlinePlayableTawkPill/InlinePlayableTawkPill";
import {
  TawkColorsProvider,
  tawksColorsWithCharacteristicHue,
} from "../../Infrastucture/TawkitColorsProvider";

// import { TopAnnotation } from "../TopAnnotation/TopAnnotation";

export interface EchoConfig {
  kind: "EchoConfig";
  echoText: string;
  authorProfilePicId: string;
  topAnnotationConfig: TopAnnotationConfig;
  tawkPillConfig: InlinePlayableTawkPillConfig;
  textColorsProvider: TawkColorsProvider;
}

export const echoConfigDemo1: EchoConfig = {
  kind: "EchoConfig",
  echoText:
    "This is the echo Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas, Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas, Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas, Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas",
  authorProfilePicId: "ProfilePictures/default",
  topAnnotationConfig: topAnnotationDemoProps1,
  tawkPillConfig: inlinePlayableTawkPillConfigDemo1,
  textColorsProvider: tawksColorsWithCharacteristicHue(0.5),
};

export function Echo(props: EchoConfig): JSX.Element {
  const { echoText, authorProfilePicId } = props;
  return (
    <div
      className="echo-wrapper"
      style={{ backgroundColor: props.textColorsProvider.color5TextBubble }}
    >
      <button type="button" className="echo-profile-pic-button">
        <Image
          className="echo-profile-pic"
          publicId={authorProfilePicId}
          cloudName="dfno6k3qf"
          secure="true"
        >
          <Transformation
            width="100"
            height="100"
            gravity="face"
            dpr="auto"
            crop="fill"
          />
        </Image>
      </button>

      <p className="echo-text-itself">{echoText}</p>

      <div className="echo-top-ann-and-tawk-pill">
        <div className="echo-top-annotation">
          <TopAnnotation {...props.topAnnotationConfig} />
        </div>

        <div className="echo-tawk-pill">
          <InlinePlayableTawkPill {...props.tawkPillConfig} />
          {/* <TawkPill {...props.tawkPillConfig} /> */}
        </div>
      </div>
    </div>
  );
}
